/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Compliance_Bfsg_LinkInputs */

const en_landing_compliance_bfsg_link = /** @type {(inputs: Landing_Compliance_Bfsg_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read the accessibility statement`)
};

const de_landing_compliance_bfsg_link = /** @type {(inputs: Landing_Compliance_Bfsg_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erklärung zur Barrierefreiheit lesen`)
};

const fr_landing_compliance_bfsg_link = /** @type {(inputs: Landing_Compliance_Bfsg_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lire la déclaration d’accessibilité`)
};

const es_landing_compliance_bfsg_link = /** @type {(inputs: Landing_Compliance_Bfsg_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leer la declaración de accesibilidad`)
};

const it_landing_compliance_bfsg_link = /** @type {(inputs: Landing_Compliance_Bfsg_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leggi la dichiarazione di accessibilità`)
};

const nl_landing_compliance_bfsg_link = /** @type {(inputs: Landing_Compliance_Bfsg_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lees de toegankelijkheidsverklaring`)
};

const pl_landing_compliance_bfsg_link = /** @type {(inputs: Landing_Compliance_Bfsg_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przeczytaj deklarację dostępności`)
};

const fi_landing_compliance_bfsg_link = /** @type {(inputs: Landing_Compliance_Bfsg_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lue saavutettavuusseloste`)
};

const da_landing_compliance_bfsg_link = /** @type {(inputs: Landing_Compliance_Bfsg_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Læs tilgængelighedserklæringen`)
};

const sv_landing_compliance_bfsg_link = /** @type {(inputs: Landing_Compliance_Bfsg_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Läs tillgänglighetsredogörelsen`)
};

/**
* | output |
* | --- |
* | "Read the accessibility statement" |
*
* @param {Landing_Compliance_Bfsg_LinkInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_compliance_bfsg_link = /** @type {((inputs?: Landing_Compliance_Bfsg_LinkInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Compliance_Bfsg_LinkInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_compliance_bfsg_link(inputs)
	if (locale === "fr") return fr_landing_compliance_bfsg_link(inputs)
	if (locale === "es") return es_landing_compliance_bfsg_link(inputs)
	if (locale === "it") return it_landing_compliance_bfsg_link(inputs)
	if (locale === "nl") return nl_landing_compliance_bfsg_link(inputs)
	if (locale === "pl") return pl_landing_compliance_bfsg_link(inputs)
	if (locale === "fi") return fi_landing_compliance_bfsg_link(inputs)
	if (locale === "da") return da_landing_compliance_bfsg_link(inputs)
	if (locale === "sv") return sv_landing_compliance_bfsg_link(inputs)
	return en_landing_compliance_bfsg_link(inputs)
});